import React,{useState} from 'react';
import {useTheme} from "../../UI/Theme/ThemeContext";
import {DataOutletContainerStyled} from "../../../styled/Resume";
import OutletHeader from "../Tools/OutletHeader";
import OptimizePageData from "../Tools/OptimizePageData";
import CreatePageData from "../Tools/CreatePageData";


const DataOutlet = (props) => {
    const {
        setActiveStep,
        DragDropHandleDrop,
        DragDropRef,
        DragDropFileError,
        DragDropFile,
        DragDropHandleUploadFile,
        clearManualUpload,
        optimizeBasicInfo,
        optimizeHandleInputChange,
        optimizeJobConnectType,
        optimizeJobTypesArray,
        optimizeHandleJobConnectType,
        optimizeSetAdditionalInfo,
        optimizeAdditionalInfo,
        handleFileResumeOptimize,
        onSubmitCreate,
        addlInfoImagePreviews,
        addlInfoFileInputRef,
        triggerAddlInfoSelect,
        handleAddlInfoFileSelect,
        removeSingleAddlInfoImage,
        basicLinkInfo,
        basicHandleAddLinks,
        basicHandleDeleteLinks,
        basicHandleLinkChange,
        eduArray,
        handleEduExpChange,
        handleDeleteEduInfo,
        handleAddEduInfo,
        workExpArray,
        handleWorkExpChange,
        handleDeleteExp,
        handleAddExp,
        skills,
        handleSkillChange,
        handleDeleteSkill,
        handleAddSkill,
        awardArray,
        handleAwardChange,
        handleDeleteAward,
        handleAddAward,
        publications,
        handlePubChange,
        handleDeletePublication,
        handleAddPublication,
        languages,
        handleLangChange,
        languageStore,
        langLevelsArray,
        handleDeleteLang,
        handleAddLang,
        interests,
        setInterestsArray,
        handleInterestChange,
        handleDeleteInterests,
        handleAddInterests,
        basicInfoForward,
        eduInfoForwardOrBackward,
        workExpForwardOrBackward,
        skillsForwardOrBackward,
        certsForwardOrBackward,
        pubForwardOrBackward,
        langForwardOrBackward,
        interestsBackward,
        existingResumes,
        existingResumeSelectedIndex,
        onExistingResumeSelect,
        onExistingResumePreview,
        storedResumeSelected,
        selectedStoredResumeName,
        

    } = props;
    const {themeName} = useTheme();
    const [headerActive, setHeaderActive] = useState(1);

    return (
        <DataOutletContainerStyled theme={themeName}>
            <OutletHeader activeStep={headerActive} setActiveStep={setHeaderActive} />
            <div className="dataContent">

                {headerActive === 1 && (
                    <OptimizePageData
                        DragDropHandleDrop={DragDropHandleDrop}
                        DragDropRef={DragDropRef}
                        DragDropFileError={DragDropFileError}
                        DragDropFile={DragDropFile}
                        DragDropHandleUploadFile={DragDropHandleUploadFile}
                        clearManualUpload={clearManualUpload}
                        optimizeBasicInfo={optimizeBasicInfo}
                        optimizeHandleInputChange={optimizeHandleInputChange}
                        optimizeJobConnectType={optimizeJobConnectType}
                        optimizeJobTypesArray={optimizeJobTypesArray}
                        optimizeHandleJobConnectType={optimizeHandleJobConnectType}
                        optimizeSetAdditionalInfo={optimizeSetAdditionalInfo}
                        optimizeAdditionalInfo={optimizeAdditionalInfo}
                        handleFileResumeOptimize={handleFileResumeOptimize}
                        addlInfoImagePreviews={addlInfoImagePreviews}
                        addlInfoFileInputRef={addlInfoFileInputRef}
                        triggerAddlInfoSelect={triggerAddlInfoSelect}
                        handleAddlInfoFileSelect={handleAddlInfoFileSelect}
                        removeSingleAddlInfoImage={removeSingleAddlInfoImage}
                        storedResumeSelected={storedResumeSelected}
                        selectedStoredResumeName={selectedStoredResumeName}
                        existingResumes={existingResumes}
                        existingResumeSelectedIndex={existingResumeSelectedIndex}
                        onExistingResumeSelect={onExistingResumeSelect}
                        onExistingResumePreview={onExistingResumePreview}
                        interests={interests}
                        setInterestsArray={setInterestsArray}
                        

                    />
                )}

                {headerActive === 2 && (
                    <CreatePageData
                        setActiveStep={setActiveStep}
                        optimizeBasicInfo={optimizeBasicInfo}
                        optimizeHandleInputChange={optimizeHandleInputChange}
                        optimizeJobConnectType={optimizeJobConnectType}
                        optimizeJobTypesArray={optimizeJobTypesArray}
                        optimizeHandleJobConnectType={optimizeHandleJobConnectType}
                        optimizeSetAdditionalInfo={optimizeSetAdditionalInfo}
                        optimizeAdditionalInfo={optimizeAdditionalInfo}
                        basicLinkInfo={basicLinkInfo}
                        basicHandleAddLinks={basicHandleAddLinks}
                        basicHandleDeleteLinks={basicHandleDeleteLinks}
                        basicHandleLinkChange={basicHandleLinkChange}
                        eduArray={eduArray}
                        handleEduExpChange={handleEduExpChange}
                        handleDeleteEduInfo={handleDeleteEduInfo}
                        handleAddEduInfo={handleAddEduInfo}
                        workExpArray={workExpArray}
                        handleWorkExpChange={handleWorkExpChange}
                        handleDeleteExp={handleDeleteExp}
                        handleAddExp={handleAddExp}
                        skills={skills}
                        handleSkillChange={handleSkillChange}
                        handleDeleteSkill={handleDeleteSkill}
                        handleAddSkill={handleAddSkill}
                        awardArray={awardArray}
                        handleAwardChange={handleAwardChange}
                        handleDeleteAward={handleDeleteAward}
                        handleAddAward={handleAddAward}
                        publications={publications}
                        handlePubChange={handlePubChange}
                        handleDeletePublication={handleDeletePublication}
                        handleAddPublication={handleAddPublication}
                        languages={languages}
                        handleLangChange={handleLangChange}
                        languageStore={languageStore}
                        langLevelsArray={langLevelsArray}
                        handleDeleteLang={handleDeleteLang}
                        handleAddLang={handleAddLang}
                        interests={interests}
                        handleInterestChange={handleInterestChange}
                        handleDeleteInterests={handleDeleteInterests}
                        handleAddInterests={handleAddInterests}
                        basicInfoForward={basicInfoForward}
                        eduInfoForwardOrBackward={eduInfoForwardOrBackward}
                        workExpForwardOrBackward={workExpForwardOrBackward}
                        skillsForwardOrBackward={skillsForwardOrBackward}
                        certsForwardOrBackward={certsForwardOrBackward}
                        pubForwardOrBackward={pubForwardOrBackward}
                        langForwardOrBackward={langForwardOrBackward}
                        interestsBackward={interestsBackward}
                        onSubmitCreate={onSubmitCreate}
                    />
                )}


            </div>


        </DataOutletContainerStyled>
    );
}

export default DataOutlet;